const accordionsClosed = (selector) => {
  $(document).ready(function($2) {
    var delay = 100;
    setTimeout(function() {
      $2(".elementor-tab-title").removeClass("elementor-active");
      $2(".elementor-tab-content").css("display", "none");
    }, delay);
  });
};
export default accordionsClosed;
